import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import {
    Avatar,
    CardHeader,
    Dialog,
    DialogContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    wrapper: {
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
    },
    header: {
        padding: "8px 16px 8px 0",
        "& .MuiCardHeader-content": {
            overflow: "hidden",
        },
        "& .MuiCardHeader-avatar": {
            marginRight: 8,
        },
        [theme.breakpoints.down("sm")]: {
            padding: "4px 8px 4px 0",
        },
    },
    imageModal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageModalContent: {
        outline: "none",
        maxWidth: "90vw",
        maxHeight: "90vh",
    },
    expandedImage: {
        width: "100%",
        height: "auto",
        maxWidth: "500px",
        borderRadius: theme.spacing(1),
    },
    clickableAvatar: {
        cursor: "pointer",
        width: 40,
        height: 40,
        [theme.breakpoints.down("sm")]: {
            width: 36,
            height: 36,
        },
        "&:hover": {
            opacity: 0.8,
        },
    }
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
    const classes = useStyles();
    const [imageModalOpen, setImageModalOpen] = useState(false);

    const handleImageClick = (e) => {
        e.stopPropagation();
        if (contact?.urlPicture) {
            setImageModalOpen(true);
        }
    };

    const contactName = contact?.name || "(sem contato)";
    const subheader = [
        ticket?.id ? `#${ticket.id}` : null,
        ticket?.user
            ? `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
            : null,
    ].filter(Boolean).join(" · ");

    return (
        <React.Fragment>
            <div className={classes.wrapper}>
                <CardHeader
                    className={classes.header}
                    onClick={onClick}
                    style={{ cursor: "pointer" }}
                    titleTypographyProps={{ noWrap: true, variant: "subtitle1" }}
                    subheaderTypographyProps={{ noWrap: true, variant: "caption" }}
                    avatar={
                        <Avatar
                            src={contact?.urlPicture}
                            alt="contact_image"
                            className={classes.clickableAvatar}
                            onClick={handleImageClick}
                        >
                            {contactName.charAt(0)}
                        </Avatar>
                    }
                    title={contactName}
                    subheader={subheader}
                />
            </div>

            <Dialog
                open={imageModalOpen}
                onClose={() => setImageModalOpen(false)}
                className={classes.imageModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent className={classes.imageModalContent}>
                    <img
                        src={contact?.urlPicture}
                        alt={contact?.name || "Foto do contato"}
                        className={classes.expandedImage}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketInfo;
